import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { moduleActionContext } from '@/store';
const teamsModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default teamsModule;
export const teamsModuleActionContext = (context) => moduleActionContext(context, teamsModule);
